import styled from 'styled-components';

export const Index = styled.div`
  min-height: 200vh;
  position: relative;
  display: flex;
  flex-direction: column;

  > .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1100;
    background-color: rgba(7, 10, 16, 1);
  }
  > .top-bg {
    width: 100%;
    height: 929px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1000;

    display:flex;
    justify-content:center;
    overflow:hidden;
    >.img{
        height:100%;
    }
  }
  > .center-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -900;
  }
  > .bottom-bg {
    width: 100%;
    height: 929px;
    z-index: -1000;
    position: absolute;
    /* bottom: 0; */
    /* bottom: ${props => props.footerHeight}px; */
    /* bottom:calc(642px - 97px); */
    bottom:452px;
    left: 0;

    display:flex;
    justify-content:center;
    overflow:hidden;
    >.img{
        height:100%;
    }
  }
`;

export const Decoration = styled.div`
  position: absolute;
  top: 0;
  bottom: calc(642px - 97px);
  left: 0;
  width: 100%;
  z-index: -900;
`;

export const TopAdvertisement = styled.div``;

export const Header = styled.div``;

export const Menu = styled.div`
  margin-top: 17px;
`;

export const ShopMenu = styled.div`
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 14px;
`;

export const Content = styled.div``;

export const Footer = styled.div`
  margin-top: auto;
`;

export const Model = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;

  background: rgba(0, 0, 0, 0.8);
`;

export const Service = styled.div`
  position: absolute;
  top: 160px;
  left: 648px;
`;

export const GoodsList = styled.div`
  position: absolute;
  top: 133px;
  left: 380px;
`;

export const LoginForm = styled.div`
  top: 160px;
  left: 648px;
  width: 462px;
  height: 571px;
`;
